import { getCheckingFetches, resetFetches } from "./checkingFetches";
let controller;
let signal;
export function getSignal() {
    return signal;
}
export function resetAbortHandling() {
    if (getCheckingFetches().length) {
        // doing a little cleanup
        if (controller && signal) {
            controller.abort("refreshing content");
        }
        controller = new AbortController();
        signal = controller.signal;
        resetFetches();
    }
}
